<template>
    <div v-if="item" class="">
        <div v-if="item.type == 'RESIDENTIAL'" class="row g-4">
            <div class="col-12">
                <label class="small text-muted">Street Address:</label>
                <h6 class="mb-0">{{ item.street_address }}</h6>
            </div>
            <div class="col-sm-6">
                <label class="small text-muted">State:</label>
                <h6 v-if="item.state" class="mb-0">{{ item.state.name }}</h6>
            </div>
            <div class="col-sm-6">
                <label class="small text-muted">Local Government:</label>
                <h6 v-if="item.lga" class="mb-0">
                    {{ item.lga.name }}
                </h6>
            </div>
        </div>
        <div v-if="item.type == 'ORIGIN'" class="row g-4">
            <div class="col-12">
                <label class="small text-muted">Polling Unit:</label>
                <h6 v-if="item.unit" class="mb-0">{{ item.unit.name }}</h6>
            </div>
            <div class="col-sm-6">
                <label class="small text-muted">Ward:</label>
                <h6 v-if="item.ward" class="mb-0">{{ item.ward.name }}</h6>
            </div>
            <div class="col-sm-6">
                <label class="small text-muted">Local Government:</label>
                <h6 v-if="item.lga" class="mb-0">
                    {{ item.lga.name }}
                </h6>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        item: {
            type: Object,
        }
    }
}
</script>

<style>

</style>